import React, { useCallback } from 'react'

import clsx from 'clsx'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import Hub from './components/Hub'

import classes from './ContentHubs.module.scss'

/* eslint-disable import/no-duplicates -- Swiper module CSS imports are side-effect imports. */
import 'swiper/css'
import 'swiper/css/pagination'
/* eslint-enable import/no-duplicates */

const SWIPER_BREAKPOINTS_CONFIG = {
  0: {
    slidesPerView: 1,
    spaceBetween: 16,
  },
  600: {
    slidesPerView: 2,
    spaceBetween: 16,
  },
  960: {
    slidesPerView: 4,
    spaceBetween: 24,
  },
}

/** @type {import("./types").default} */
const ContentHubs = ({ contentHubs }) => {
  const { sendEvent } = useEventContext()

  const onPageChange = useCallback(() => {
    sendEvent({
      engagementComponent: 'category_hub',
      engagementDestination: 'article_change-page',
      engagementDetails: 'bullet-point',
      name: 'engagement_facet_click',
    })
  }, [sendEvent])

  return (
    <div className={clsx('ContentHubs', classes.root)}>
      <Typography variant="heading-lg" className={classes.heading} component="h2">
        Explore curated content and tools
      </Typography>
      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true, el: '#hubs-pagination' }}
        breakpoints={SWIPER_BREAKPOINTS_CONFIG}
        onPaginationUpdate={() => {
          const bullets = document.querySelectorAll('.swiper-pagination-bullet')
          if (bullets) {
            bullets.forEach(bullet => bullet.addEventListener('click', onPageChange))
          }
        }}
      >
        {contentHubs.map((hub, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <SwiperSlide key={i}>
            <Hub {...hub} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div id="hubs-pagination" className={classes.pagination} />
    </div>
  )
}

export default ContentHubs
